import iviewLocale from 'iview/src/locale/lang/mn-MN';

export default {
    "locale": "mn-MN",
    "user": {
        "defaultMenu": "Негізгі мәзір",
        "pleaseWait": "Сәл күте тұрыңыз!",
        "role": "Міндет",
        "title": "Ламбда платформасы",
        "subtitle": "Ламбда платформасы",
        "login": "Кіру",
        "forgot": "Құпия сөзіңізді ұмыттыңыз ба?",
        "remember": "Осы компьютерге арналған еске салғыш",
        "loginTitle": "ЖҮЙЕГЕ КІРУ",
        "username": "Логин аты",
        "email": "Электрондық пошта",
        "password": "Құпия сөз",
        "loginSuccess": "Жүйеге сәтті кіріңіз. Сәл күте тұрыңыз!",
        "loginError": "Логин немесе пароль қате!!!",
        "emailRequired": "Электрондық пошта мекенжайыңызды енгізіңіз",
        "emailSendError": "Электрондық поштаны жіберу кезінде қате орын алды",
        "forgotDescription": "Электрондық пошта мекенжайыңызды енгізіңіз және құпия сөзіңізді қалпына келтіріңіз",
        "sendPasswordResetCode": "Құпия сөзді өзгерту кодын электрондық пошта арқылы алыңыз",
        "passwordConfirm": "Құпия сөзді тексеру",
        "userNotFound": "Пайдаланушы табылмады!!!",
        "codeSentError": "Құпия сөзді қалпына келтіру кодын жіберу қатесі!",
        "passwordReset": "ҚҰПИЯ СӨЗДІ ЖАҢАРТУ",
        "passwordResetCode": "Құпия сөзді қалпына келтіру коды",
        "passwordResetCodeSent": "Құпия сөзді қалпына келтіру коды сәтті жіберілді!",
        "passwordResetCodeRequired": "Құпия сөзді өзгерту коды енгізілмеген !!!",
        "passwordResetSuccess": "Құпия сөз сәтті жаңартылды!",
        "passwordConfirmError": "Құпия сөзді тексеру сәтсіз аяқталды!!!",
        "passwordResetCodeIncorrect": "Құпия сөзді қалпына келтіру коды дұрыс емес !!!",
        "passwordResetCodeTimeout": "Құпия сөзді қалпына келтіру кодының мерзімі бітті!!!",
        "noReply": "Бұл электрондық пошта автоматты түрде жіберілді, сондықтан жауап берудің қажеті жоқ.",
        "databaseview": "Мәліметтер қоры, көрініс",
        "dataBase": "дерекқор",
        "view": "қараңыз",
        "add": "қосу",
        "characteristics": "Сипаттамалары",
        "basic": "Түбір",
        "column": "Баған",
        "name": "Аты",
        "optional": "Қосымша",
        "filter": "Сүзгі",
        "data": "Деректер",
        "save": "Сақтау",
        "tableList": "Кестелер тізімі",
        "aggregation": "Біріктіру",
        "sort": "Сұрыптау",
        "use": "Қолдану",
        "grouping": "Топтастыру",
        "type": "Түр",
        "alias": "Жалған есім",
        "dataProcessing": "Мәліметтерді өңдеу",
        "select": "Таңдаңыз",
        "pleaseEnterSearchValue": "Іздеу сөзіңізді енгізіңіз...",
        "user": "пайдаланушы",
        "users": "Тұтынушылар",
        "totalEmployees": "Жалпы қызметкерлер",
        "deleted": "Жойылды",
        "searchForInformation": "Ақпаратта іздеу",
        "addUser": "Пайдаланушы қосу",
        "noData": "Ешқандай ақпарат табылмады",
        "page": "Бетінде",
        "shows": "көрсетеді",
        "categorySearch": "Дәрежелер бойынша төреші",
        "image": "Інжір",
        "lastName": "Тегі",
        "firstName": "Аты",
        "registrationNumber": "Тіркеу нөмірі",
        "dateOfBirth": "Туған жылы",
        "gender": "Жыныс",
        "men": "Еркек",
        "women": "Әйел",
        "phone": "Телефон",
        "resetFrom": "Жаңасын толтырыңыз",
        "permission": "Қол жеткізу құқығы",
        "loginName": "Логин аты",
        "confirmPassword": "Құпия сөзді тексеру",
        "personalInformation": "Жеке ақпарат",
        "changePassword": "Құпия сөзді өзгерту",
        "settings": "Параметрлер",
        "logOut": "Шығу",
        "pleaseSelectRole": "Рөлді таңдаңыз",
        "administraationRightsManagment": "Қол жеткізуді басқару",
        "additional": "Қосымша",
        "dataSource": "Ақпараттың дереккөзі",
        "chart": "Графика",
        "userList": "Пайдаланушылар тізімі",
        "import": "Енгізіңіз",
        "register": "Тіркелу",
        "confirm": "Растау",
        "menuSelection": "Мәзірді таңдаңыз",
        "noMatchingData": "Сәйкес деректер жоқ",
        "nickName": "Көрсетілетін атау",
        "note": "Түсіндіру",
        "pleaseEnterVisibleName": "Көрсетілетін атауды енгізіңіз",
        "firstNameandLastName": "Тегі",
        "mobile": "Ұялы телефон",
        "createdDate": "Жасалу күні",
        "registrationregistrationConfirmedConfirmed": "ТІРКЕЛУ РЕТТЕЛДІ",
        "registrationIsNotConfirmed": "ТІРКЕЛУ РАСТАМАДЫ",
        "success": "Сәтті",
        "systemUpdate": "Жүйені жаңарту",
        "sendDataStructure": "Деректер құрылымдарын жіберу",
        "pleaseReEnterYourPassword": "Құпия сөзіңізді қайта енгізіңіз бе?",
        "theValueIsRegistered": "мәні тіркелген",
        "possibleTableView": "Ықтимал кесте және көрініс",
        "table": "Кесте",
        "ascending": "өсу",
        "descending": "Азайту",
        "byLoginName": "Логин аты ретінде",
        "dateAdded": "Қосылған күні",
        "inPage": "Бетінде",
        "show": "көрсетеді",
        "outOf": "Барлығы",
        "fromUsers": "пайдаланушылардан",
        "showing": "көрсетеді",
        "noInfo": "Ақпарат жоқ",
        "ruconfinfo": "Қызметкер деректерін қалпына келтіргіңіз келетініне сенімдісіз бе?",
        "ruconfinfoDelete": "Қызметкер деректерін біржола жойғыңыз келетініне сенімдісіз бе?",
        "created": "Құрылды",
        "userDeleted": "Пайдаланушы жойылды",
        "_logout": "Шығу",
        "_cancel": "Тоқта",
        "listOfDeletedUsers": "Жойылған пайдаланушылардың тізімі",
        "by": " - арқылы",
        "no": "Жоқ",
        "yes": "Иә",
        "completeDestruction": "Толық жою",
        "recovery": "Қалпына келтіру",
        "errorOccWhileDeleting": "Жою кезінде қате орын алды",
        "userInformationRestored": "Пайдаланушы ақпараты қалпына келтірілді",
        "errorOccurredWhileRetrievingData": "Деректерді алу кезінде қате орын алды.",
        "total": "Барлығы",
        "edit": "Түзет",
        "pleaseLogInUsingYourRegUnamePassword": "Тіркелген логин мен парольді пайдаланып жүйеге кіріңіз!",
        "frequentlyAskedQuestions": "Жиі Қойылатын Сұрақтар",
        "toContaqt": "хабарласу",
        "downloadYourMobileApp": "Мобильді қолданбаны жүктеп алыңыз.",
        "instructionsUse": "Қолдану нұсқаулары",
        "hayg": "Моңғолия, Улан-Батор қаласы, Сүхбаатар ауданы, 9-аудан, 54, Computer Mall, 8-қабат, №8002",
        "plseResUrPassUsingUrRegisteredEmail": "Тіркелген электрондық пошта мекенжайын пайдаланып құпия сөзді қалпына келтіргіңіз келе ме?",
        "downloadAppHere": "Қолданбаны осы жерден жүктеп алыңыз",

        "learningManagementSystem": "Оқытуды басқару жүйесі",
        "amjilt": "Жетістік",
        "system_features": "Жүйе мүмкіндіктері",
        "ebs": "Бастауыш мектеп",
        "web_site_data_monitoring": "Веб-сайт деректерін бақылау",
        "training_data_statistics": "Оқыту деректерінің статистикасы",
        "schedule_report": "Есепті жоспарлау",
        "track_by_keyword": "Кілт сөз бойынша қадағалау",
        "to_calculate_the_program_choice_of_teachers_and_students": "Мұғалімдер мен студенттердің бағдарлама таңдауын есептеу",
    },
    "agent_wizard": {
        "confirm_registration_information": "Тіркеу ақпаратын тексеріңіз",
        "step": "Қадам",
        "hello": "Қалдарыңыз қалай?",
        "your_name": "Сіздің атыңыз",
        "your_last_name": "Сіздің фамилияңыз",
        "name_desc": "Шын аты-жөніңізді латын немесе моңғол әріптерімен 75 таңбаға дейін жазыңыз.",
        "last_name_desc": "Фамилияңызды латын немесе моңғол әріптерімен 75 таңбаға дейін жазыңыз.",
        "your_birthday": "Сіздің туған күніңіз",
        "your_gender": "Сіздің жынысыңыз",
        "women": "Әйел",
        "man": "Еркек",
        "_register": "Тіркеу нөмірі",
        "register_desc": "Тіркеу нөміріңізді енгізіңіз. Тек моңғол әріптерімен жазыңыз.",
        "example": "Мысалы",
        "contact_information": "Байланыс ақпараты",
        "your_email_address": "Сіздің электронды пошта адресіңіз",
        "email_desc": "Электрондық пошта мекенжайыңызды енгізіңіз. Латын әріптерімен, кіші әріптермен және бос орынсыз жазыңыз.",
        "your_phone_number": "Сіздің ұялы телефон нөміріңіз",
        "phone_desc": "Ұялы телефон нөміріңізді енгізіңіз. Тек сандарды пайдаланыңыз және арасында бос орын болмауы керек.",
        "profile_image": "Профиль суреті",
        "profile_image_uploud": "Профиль суретін қосыңыз",
        "profile_desc": "Профиль суретіңізді таңдап, оны серверге жүктеңіз. Кескін өлшемі біркелкі пропорцияда 1мб аспауы керек.",
        "your_new_password": "Сіздің жаңа құпия сөзіңіз",
        "password_desc": "Құпия сөз латын әріптерімен, бас және кіші әріптерден, сандардан, арнайы белгілерден тұруы және бос орындар болмауы керек.",
        "rep_your_new_password": "Жаңа құпия сөзіңізді қайта растаңыз",
        "_prev": "Алдыңғы",
        "_next": "Келесісі",
        "enter_personal_information": "Жеке мәліметтеріңізді дұрыс енгізіңіз!",
        "enter_contact_information": "Байланыс ақпаратыңызды дұрыс енгізіңіз!",
        "please_change_your_password": "Құпия сөзіңізді өзгертіңіз! Жаңадан енгізілген құпия сөзіңіз болашақта пайдаланылады",
        "please_contact_system_administor": "Қандай да бір көмек қажет болса, жүйе әкімшісіне хабарласыңыз",
        "back": "Қайтып келу",
        "entered_information": "Сіз беретін ақпарат",
        "information_alert": "Ақпаратыңызды қарап шығыңыз және дұрыс болса жүйеге жіберіңіз.",
        "no_information": "ақпарат жоқ",
        "date_you_added_system": "Жүйеге қосылған күн",
        "send_registration": "Тіркеуді жіберіңіз",
        "userDeleted": "Пайдаланушы жойылды.",
        "errorOccurredDeleting": "Жою кезінде қате орын алды.",
        "UserInformationRestored": "Пайдаланушы ақпараты қалпына келтірілді.",
        "ErrorRetrievingData": "Деректерді алу кезінде қате пайда болды!",
        "NoSearchResultsFound": "Іздеу нәтижелері табылмады!",
        "SpacesAreIncluded": "Бос орын енгізілді."
    },
    "adminModule": {
        "db": "Дерекқор",
        "usersAndUserGroups": "ПАЙДАЛАНУШЫ ЖӘНЕ ҚОЛДАНУ ҚҰҚЫҚТАРЫ",
        "users": "Тұтынушылар",
        "userGroupsPermission": "Қол жеткізу және келісім",
        "sendDBSchema": "Дерекқор құрылымын жіберіңіз",
        "AddColumn": "Баған қосыңыз",
        "systemUpdate": "Жүйені жаңарту",
        "graphic": "Графика",
        "column": "Баған",
        "dataType": "Деректер түрі",
        "form": "Пішін",
        "table": "Кесте",
        "original_preparation": "Бастапқы дайындық",
        "pleaseWait": "Сәл күте тұрыңыз!",
        "_form": "Пішін",
        "value_column": "Мән бағаны",
        "Custom_column": "Пайдаланушы бағаны",
        "list_grid": "Тізім | Grid (сүзгі)",
        "judgment_column": "Бағалау бағанасы",
        "form_value": "Пішін (Алатын мән)",
        "InformationSuccessfullyDistributed": "Деректер сәтті таратылды!",
        "InformationReturned": "Ақпарат қайтарылды!"
    },
    "graphql": {
        "graphqlManagement": "Graphql басқару",
        "table": "Кесте",
        "selectTable": "Кестені таңдаңыз",
        "name": "Аты",
        "idField": "ID өріс",
        "hideFields": "Өрістерді жасыру",
        "permissionActions": "Бекіту әрекеттері",
        "add": "қосу",
        "edit": "Түзет",
        "delete": "Жою",
        "save": "Сақтау",
        "accessAndAccessRights": "Кіру және кіру",
        "nevtersenHundHaruulah": "Жүйеге кірген адамға көрсетіледі.",
        "accessRights": "Көрінетін қол жеткізу",
        "allUsersCanSee": "Рұқсат берілмейінше барлық пайдаланушылар көре алады.",
        "subTables": "Ішкі кестелер",
        "subTable": "Ішкі кесте",
        "connectionField": "Қосылу өрісі",
        "tableList": "Кестелер тізімі",
        "viewList": "View Тізім",
        "real_time": "Нақты уақыттағы брондау",
        "cancel": "Тоқта",
        "tableParentId": "Ата-аналар кестесі ID",
        "action": "Әрекет"
    },
    "components": {
        "add": "қосу",
        "pleaseEnterSearchValue": "Іздеу сөзіңізді енгізіңіз...",
        "pleaseWait": "Сәл күте тұрыңыз!",
        "deleteData": "Деректерді жою керек пе?",
        "name": "Аты",
        "yes": "Иә",
        "no": "Жоқ",
        "copy": "Көшіру",
        "table": "Кесте",
        "basicTable": "Негізгі кесте",
        "selectTable": "Кестені таңдаңыз",
        "applications": "Бағдарламалар",
        "additions": "Қосымшалар",
        "logistics": "Логистика",
        "letter": "Хат",
        "fileDirectory": "Файл кітапханасы",
        "admin": "Админ",
        "systemAdministrator": "Жүйелік админ",
        "personalInformation": "Жеке ақпарат",
        "settings": "Параметрлер",
        "logOut": "Шығу",
        "changePassword": "Құпия сөзді өзгерту",
        "projectList": "Жобалар тізімі",
        "table_list": "Кестелер тізімі",
        "ui_builder": "UI құрастырушы",
        "_form": "Пішін",
        "someContents": "Кейбір мазмұн",
        "_cancel": "Тоқта"
    },
    "chart": {
        "horizontal_value": "Айқас мағына",
        "groupBy": "топтастыру",
        "line": "Сызғыш",
        "_big": "Том",
        "_small": "Кішкентай",
        "field": "Өріс",
        "settings": "Параметрлер",
        "icon": "Інжір",
        "bg_color": "Матаның түсі",
        "text_color": "Мәтін түсі",
        "link_title": "Тақырып сілтемесі",
        "link": "Сілтеме",
        "values": "Мағынасы",
        "element_type": "Элемент түрі",
        "_filter": "Сүзгі",
        "_name": "Аты",
        "responsible_value": "Жауапкершіліктің мәні",
        "_save": "Сақтау",
        "enter_name": "Атын енгізіңіз...",
        "data_table": "Деректер кестесі",
        "selectTable": "Кестені таңдаңыз",
        "aggregation": "Біріктіру",
        "no": "Жоқ",
        "count": "Сан",
        "_max": "Көпшілігі",
        "_min": "Шектен асқанда",
        "_avg": "Орташа",
        "_sum": "Sum",
        "count_distinct": "Сан",
        "avg_distinct": "Орташа айырмашылық",
        "sum_distinct": "Типтік қосынды",
        "_sort": "Сұрыптау",
        "no_sort": "Сұрыпталмаған",
        "grouping": "Топтастыру",
        "_type": "Түр",
        "fictitious_name": "Жалған есім",
        "_color": "Түс"
    },
    "dataForm": {
        "resetFrom": "Жаңасын толтырыңыз",
        "save": "Сақтау",
        "pleaseWait": "Сәл күте тұрыңыз!",
        "fillInTheNewOne": "Жаңасын толтырыңыз",
        "close": "Жабық",
        "basicSettings": "Негізгі параметрлер",
        "configureTheData": "Деректерді орнату",
        "trigger": "Триггер",
        "informationLink": "Ақпараттық сілтеме",
        "GetValuesFromTheTable": "Кестеден мән алыңыз",
        "Geographic": "Географиялық",
        "AdditionalValues": "Қосымша мәндер",
        "selectMultipleImg": "Бірнеше кескінді таңдау керек пе",
        "TypeOfTheEditor": "Редактор түрі",
        "Placeholder": "Ауыстыру",
        "default_Value": "Әдепкі мән",
        "Get_value_parameter": "Параметрден мән алыңыз",
        "Parameter_name": "Параметрдің аты",
        "Get_user_ID": "Пайдаланушы идентификаторын алу керек пе, жоқ па",
        "Consolidation_formula": "Агрегация формуласы",
        "Whether_to_summarize": "Оны бірге көрсету керек пе",
        "Choose_a_formula": "Формула таңдаңыз",
        "Formula_type": "Формула түрі",
        "Take_the_word_before_merger": "Жиналыс алдында сөз алу үшін",
        "example": "Мысалы",
        "total": "жалпы",
        "number": "саны",
        "ets": "т.б",
        "Symbol": "Таңба",
        "get_sign_after_merger": "Біріктіруден кейін баға алсаңыз",
        "Verification_conditions": "Шарттарды тексеру",
        "Form_of_data_verification": "Деректерді тексеру нысаны",
        "Password_settings": "Құпия сөз параметрлері",
        "Password_verification": "Құпия сөзді тексеру",
        "_pass": "Құпия сөз",
        "Create_a_password": "Құпиясөзді құру",
        "Check_password_during_editing": "Өңдеу кезінде құпия сөзді тексеру",
        "number_precision": "Төсектің дәлдігі",
        "Whether_get_values_database": "Мәндерді базадан алу керек пе",
        "Choose_multiple_values": "Бірнеше мәнді таңдаңыз",
        "value": "Мағынасы",
        "visible_word": "Көрінетін сөз",
        "visible_thumb": "Суретті көру",
        "add": "қосу",
        "table": "Кесте",
        "selectTable": "Кестені таңдаңыз",
        "Related_fields": "Қатысты өріс",
        "Visible_fields": "Көрінетін өрістер",
        "Select_fields": "Өрістерді таңдаңыз",
        "Sort_field": "Сұрыптау өрісі",
        "Father_column": "Негізгі баған",
        "form": "Ол пішінде",
        "this_table": "осы кестенің",
        "Display_Add_Data_button": "Деректерді қосу түймесін көрсету",
        "Add_data_Form": "Деректер пішінін қосыңыз",
        "List_of_tables": "Кестелер тізімі",
        "Link_terms": "Сілтеме шарттары",
        "Get_customer": "Пайдаланушыдан алыңыз",
        "Custom_column": "Пайдаланушы бағаны",
        "judgment_column": "Бағалау бағанасы",
        "Call_from_server": "Серверден қоңырау шалу",
        "data_loading_URL": "Деректерді алу үшін URL",
        "Trigger_load_time": "Триггерді шақыратын уақыт",
        "Example_data_returned_server": "Серверден қайтарылатын деректердің мысалы",
        "Successful": "Іске сәт",
        "URL_call_information_link": "Ақпараттық сілтемеге қоңырау шалу үшін URL",
        "Value_table": "Мәндер кестесі",
        "Value_return_field": "Мәнді қайтаратын өріс",
        "Geographic_settings": "Географиялық параметрлер",
        "attribute": "Атрибут",
        "properties": "сипаттамалары",
        "Geometric_type": "Геометриялық түрі",
        "point": "Нүкте",
        "line": "Сызғыш",
        "polygon": "Көпбұрышты",
        "length_center": "Орталық бойлық",
        "latitude_center": "Орталық ендік",
        "Map_magnification": "Картаны масштабтау",
        "Background_map": "Фондық сурет",
        "Google_Street": "Google Көше",
        "Google_Space": "GoogleҒарыш",
        "Open_Street_Map": "Көше суретін ашыңыз",
        "Check_overlap_area": "Өрістің қабаттасуын тексеру",
        "Feature_Class_link": "Feature Class сілтеме",
        "Search_field": "Іздеу өрісі",
        "Search_value_field": "Іздеу мәнін алу үшін өріс",
        "Success_message": "Сәттілік хабары",
        "Error_message": "Қате туралы хабар",
        "Form_name": "Пішіннің аты",
        "Sub_name": "Субтитр",
        "Form_type": "Пішін түрі",
        "Simple_form": "Қарапайым пішін",
        "Step_by_step_form": "Қадамдары бар пішін",
        "data_table": "Деректер кестесі",
        "idField": "ID өрісі",
        "Date_generated_automatically": "Күн автоматты түрде жасалады",
        "render_by_tab": "Бөлімді қойындыға айналдырыңыз",
        "Label_location": "Белгі орны",
        "Form_width": "Пішін ені",
        "Save_button_word": "Түйме сөзін сақтау",
        "Padding_spacing": "Толтырғыш - аралық",
        "model": "Үлгі",
        "displayName": "Көрсетілетін атау",
        "hide": "Жасыру",
        "inactive": "Белсенді емес",
        "translation": "Аударма",
        "formula": "Формула",
        "userInterface": "Сыртқы түрі",
        "_subform": "Ішкі пішін",
        "_form": "Пішін",
        "formula_conditions": "Формулалар мен шарттар",
        "field": "Өріс",
        "basic_from": "Негізгі форма",
        "conditions": "Шарттар",
        "add_a_field": "Өріс қосыңыз",
        "controller_namespace": "Controller namespace",
        "namespace": "Атау кеңістігі",
        "before_insert": "Қосар алдында",
        "after_insert": "Қосқаннан кейін",
        "before_update": "Жаңарту алдында",
        "after_update": "Жаңартудан кейін",
        "_type": "Түр",
        "_top": "жоғарғы",
        "_left": "сол",
        "Choose_type": "Түрді таңдаңыз",
        "min_height": "min-height",
        "Close_deletion_action": "Жою әрекетін жабу",
        "close_add_ons_action": "Қосу әрекетін жабу",
        "row_numbering": "Жолды нөмірлеу",
        "Use_table_type": "Кесте түрлерін қолданыңыз",
        "Table_Type_field": "Кесте түрінің өрісі",
        "Table_Type_value": "Кесте түрінің мәні",
        "Consolidation_forms_and_tables": "Пішіндер мен кестелерді біріктіру",
        "_link": "Сілтеме",
        "iframe_page": "iframe бет",
        "no_action_sub_top": "Белсенді емес ішкі мәзірде көрсету",
        "No_action": "Әрекет жоқ",
        "_division": "Бөлім",
        "menuType": "Мәзір түрі",
        "connectionPath": "Қосылатын жол",
        "name": "Аты",
        "target": "Тапсырма",
        "self": "өзі",
        "blank": "бос",
        "_new": "жаңа",
        "Get_name": "Есім алу үшін",
        "section_add": "Бөлім қосу",
        "add_column": "Баған қосыңыз",
        "_delete": "Жою",
        "_move": "Жылжыту",
        "graphicsManagement": "Графиканы басқару",
        "viewPhotos": "Фотосуреттерді көру",
        "createNumber": "Сан жасау",
        "other": "Басқалар",
        "download": "Жоғары тартыңыз",
        "view": "Қараңыз",
        "pleaseSelectFile": "файлыңызды таңдаңыз",
        "longitude": "Бойлық",
        "latitude": "Ендік",
        "cancel": "Тоқта",
        "enterCoordinatesPressEnter": "Ауыстыруыңызды енгізіп, Enter пернесін басу керек пе?",
        "clickHereSelectPhoto": "Фотосуретіңізді таңдау үшін осы жерді басыңыз!",
        "notFound": "Табылмады",
        "confirmPassword": "Құпия сөзді тексеру",
        "currentPassword": "Ағымдағы құпия сөз",
        "pleaseWriting": "жазыңыз",
        "fromCityCenter": "Қала орталығынан",
        "please_enter_value": "Мән енгізіңіз",
        "formInformationSavedSuccessfully": "Пішін ақпараты сәтті сақталды.",
        "please_enter_formula": "Өз формулаңызды енгізіңіз",
        "savedSuccessfull": "Сәтті сақталды",
        "errorSaving": "Сақтау кезінде қате орын алды!",
        "formIformationSavedSuccessfull": "Пішін ақпараты сәтті сақталды.",
        "successDeleted": "Сәтті жойылды!",
        "selectDefaultMenu": "Әдепкі мәзірді таңдаңыз",
        "selectMenu": "Мәзірді таңдаңыз",
        "pleaseEnterPasswordYouUCurrentlyUsing": "Ағымдағы құпия сөзіңізді енгізіңіз",
        "pleaseReEnterYourPassword": "Құпия сөзіңізді қайта енгізіңіз бе?",
        "passwordConfirmError": "Құпия сөзді тексеру сәтсіз аяқталды!!!",
        "informationIsIncomplete": "Ақпарат толық емес",
        "trRMandatoryFieldsFillInformationLookFormAFillRequiredFieldsWithRedBorder": "Ақпаратты толтыру процесінде міндетті өрістер бар. Пішінді қараңыз және қызыл түспен белгіленген міндетті жолдарды толтырыңыз!",
        "successfullySaved": "Сәтті сақталды.",
        "pleaseDeleteSubDForm": "Ішкі пішінді жойыңыз",
        "thereZNoRightChangeInformation": "Ақпаратты өзгертуге құқығы жоқ",
        "enterCoordinatesCorrectly": "Дұрыс құпия сөзді енгізіңіз",
        "error": "Қате",
        "theSiteHasNotBeenSelected": "Өріс таңдалмаған",
        "noSiteFound": "Ешбір өріс табылмады",
        "dataNotFound": "Ешқандай деректер таңдалмаған",
        "pleaseCompleteFirstLine": "Бірінші жолды аяқтаңыз",
        "search": "Іздеу",
        "values": "Мағынасы",
        "all": "Барлық"
    },
    "dataGrid": {
        "infoCourt": "Ақпараттық сот",
        "filtering": "Соттау",
        "ruSureYouDeleteInfo": "Бұл ақпаратты шынымен жойғыңыз келе ме?",
        "yes": "Иә",
        "no": "Жоқ",
        "total": "Барлығы",
        "updateDataFromExcelFile": "Excel файлынан деректерді жаңартыңыз",
        "default_Value": "Әдепкі мән",
        "methodOfComparison": "Салыстыру әдісі",
        "parameterComparison": "Параметрлерді салыстыру",
        "whetherLookSidebarSearch": "Бүйірлік жолақты іздеуде көріну",
        "dataLink": "Деректер сілтемесі",
        "data_settings": "Деректер параметрлері",
        "basicSettings": "Негізгі параметрлер",
        "selectTable": "Кестені таңдаңыз",
        "table": "Кесте",
        "tableList": "Кестелер тізімі",
        "Related_fields": "Қатысты өріс",
        "Visible_fields": "Көрінетін өрістер",
        "Select_fields": "Өрістерді таңдаңыз",
        "Select_field": "Өрісті таңдаңыз",
        "Sort_field": "Сұрыптау өрісі",
        "Father_column": "Негізгі баған",
        "Link_terms": "Сілтеме шарттары",
        "inSearch": "Ол сотта",
        "this_table": "осы кестенің",
        "Get_customer": "Пайдаланушыдан алыңыз",
        "custom_column": "Пайдаланушы бағаны",
        "judgment_column": "Бағалау бағанасы",
        "viewList": "Тізімді қарау",
        "image": "Інжір",
        "values": "Мағынасы",
        "visible_word": "Көрінетін сөз",
        "add": "қосу",
        "linkSettings": "Сілтеме параметрлері",
        "insertList": "Сілтемені енгізу",
        "linkIcon": "Сілтеме белгішесі",
        "showOnlyIcon": "Тек суретті көрсету",
        "pinColumn": "Бағананы шегелеу",
        "linkType": "Сілтеме түрі",
        "pinPosition": "Шабу орны",
        "onLeft": "сол жағында",
        "onRight": "оң жағында",
        "radioSettings": "Radio параметрлері",
        "additionalSettings": "Қосымша параметрлер",
        "comparativeValue": "Салыстыру мәні",
        "icon": "Айкон",
        "colorCode": "Түс коды",
        "easyEdit": "Оңай түзету",
        "copy": "Көшіру",
        "view": "Қараңыз",
        "columnFilterButton": "Баған сүзгі түймесі",
        "displayTableFrame": "Кесте ауқымын көрсету",
        "displayMenuColumn": "Мәзірді бағандарда көрсету",
        "showFullText": "Толық мәтінді көрсету",
        "reboot": "Қайта жүктеу",
        "download": "Жоғары тартыңыз",
        "pleaseSelectFile": "файлыңызды таңдаңыз",
        "excelUpload": "Excel файлын жүктеп салыңыз",
        "exportExcel": "Excel файлын экспорттау",
        "landScape": "көлденең",
        "portrait": "тік",
        "paperSize": "Қағаз өлшемі",
        "print": "Басып шығару",
        "saveSearch": "Іздеуді сақтау",
        "pivotTool": "Айналмалы құрал",
        "clientRender": "Клиент рендер",
        "numbered": "Нөмірлеу",
        "comparisonModel": "Салыстыру үлгісі",
        "selectSameValues": "Бірдей мәндерді таңдаңыз",
        "multipleLinesChooseFrom": "Бір уақытта бірнеше жолды таңдаңыз",
        "width": "кең",
        "staticWidth": "Статикалық ені",
        "destroyedCanBeRestored": "Жойылғандарды қалпына келтіруге болады",
        "paging": "Беттеу",
        "edit": "Түзет",
        "name": "Аты",
        "basic": "Негізгі",
        "basicTable": "Негізгі кесте",
        "idField": "ID өріс",
        "data_table": "Деректер кестесі",
        "pleaseWait": "Сәл күте тұрыңыз!",
        "save": "Сақтау",
        "appearanceName": "Көрсетілетін атау",
        "hide": "Жасыру",
        "court": "Сот",
        "searchResults": "Іздеуде пайда болады",
        "translation": "Аударма",
        "tobePublished": "Жариялану үшін",
        "updateSelectedLineData": "Таңдалған жол үшін деректерді жаңартыңыз",
        "whenEnteringDataFromExcelFile": "Excel файлынан деректерді енгізу үшін",
        "filtersettings": "Сүзгі параметрлері",
        "excel": "Эксел",
        "model": "Үлгі",
        "updateSelectedLineDataSettings": "Таңдалған жол үшін деректерді жаңарту параметрлері",
        "fieldName": "Өріс атауы",
        "buttonName": "Түйме атауы",
        "updateAndReboot": "Жаңартыңыз және қайта жүктеңіз",
        "countingAssociatedInfo": "Қатысты ақпаратты санау",
        "relatedTable": "Қатысты кесте",
        "relatedFields": "Қатысты өріс",
        "fatherField": "Ата-аналық өріс",
        "consolidationFormulas": "Комбинациялар және формулалар",
        "formula": "Формула",
        "resultsStorageArea": "Нәтижелерді сақтауға арналған өріс",
        "consolidation": "Біріктіру",
        "consolidationType": "Агрегация түрі",
        "consolidationFormula": "Агрегация формуласы",
        "conditionTrigger": "Шарттар және триггерлер",
        "beforeCallingFromDatabase": "Дерекқордан қоңырау шалмас бұрын",
        "afterCallingFromDatabase": "Дерекқордан қоңырау шалғаннан кейін",
        "beforeDeleting": "Жою алдында",
        "afterDeleting": "Жоюдан кейін",
        "beforePrinting": "Басып шығару алдында",
        "cacheClearTriggerLabel": "Кэшті тазалау сілтемесі",
        "spreadsheetForm": "Кестелік пішін",
        "fromType": "Пішін түрі",
        "update": "Жаңарту үшін",
        "post": "Жариялау",
        "editable_UpdateLink": "Өңделетін - сілтемені жаңарту",
        "fixEntireLine": "Толық жолдармен өңдеу",
        "switchEditMode": "Өңдеу режиміне ауысыңыз",
        "withOneClick": "бір басу арқылы",
        "highlightChanges": "Өзгерістерді анықтау",
        "saveChangesBulk": "Өзгерістерді жаппай сақтау",
        "gbExcelImport": "Excel import",
        "excelImportFieldName": "Excel бағанының атауы",
        "excelImportFormTitle": "Excel енгізу кезіндегі параметрлер",
        "excelUploadSampleFile": "Мысал файлды қосыңыз",
        "excelUploadRowtoStart": "Excel файлын оқуды бастау үшін жол нөмірі",
        "excelUploadCustomUrl": "Excel файлын көшіру кезінде пайдаланылатын пайдаланушы сілтемесі",
        "excelImportModalTitle": "Excel файлынан деректерді импорттау",
        "appearance": "Сыртқы түрі",
        "dataTable": "Деректер кестесі",
        "filter": "Сүзгі",
        "mini": "Мини",
        "simple": "Қарапайым",
        "size": "Өлшем",
        "controllerNameSpace": "Басқарудың мүмкін әрекеттері",
        "namespace": "Атау кеңістігі",
        "beforeFetch": "Алмас бұрын",
        "afterFetch": "Алғаннан кейін",
        "symbol": "Таңба",
        "type": "Түр",
        "nickName": "Көрсетілетін атау",
        "filtersAndSelectedLineSettings": "Сүзгі және таңдалған жол параметрлері",
        "sort": "Сұрыптау",
        "column": "Баған",
        "delete": "Жою",
        "actions": "Әрекеттер",
        "firstColumn": "бірінші бағанда",
        "buttonEdit": "Жылдам түзету",
        "doubleClicktoEdit": "Өңдеу үшін екі рет басыңыз",
        "actionsField": "Әрекеттер өрісі",
        "performActionWithMouse": "Тінтуірмен әрекет",
        "renew": "Жаңарту",
        "tableHeaderTemplate": "Кесте тақырыбының үлгісі",
        "createHeaderTemplate": "Тақырып үлгісін жасаңыз",
        "addLine": "Жолды қосыңыз",
        "addLineBelow": "Төменде жолды қосыңыз",
        "deleteThisLine": "Бұл жолды жою керек пе?",
        "addColumnAfterThisColumn": "Осы бағаннан кейін баған қосыңыз",
        "pleaseDeleteThisCell": "Бұл қорапты жойыңыз",
        "checkModel": "Үлгіні тексеру",
        "height": "биіктігі",
        "widthu": "кең",
        "row": "түзу",
        "selectPaperSize": "Қағаз өлшемін таңдаңыз",
        "currencySelection": "Валютаны таңдаңыз",
        "tugrug": "Тегруг",
        "dollar": "Доллар",
        "euro": "Евро",
        "yen": "Жапон иені",
        "austDollar": "Австралиялық доллар",
        "rubli": "Рубль",
        "choosevalue": "Мәнді таңдаңыз",
        "pleaseWaitForLoading": "оның жүктелуін күтіңіз",
        "successfullySaved": "Сәтті сақталды.",
        "formInformationSavedSuccessfully": "Пішін ақпараты сәтті сақталды.",
        "anErrorOccurredWhileSaving": "Сақтау кезінде қате орын алды!",
        "successfullyDeleted": "Сәтті жойылды!",
        "makeExcel": "Excel шығысы",
        "plseEnterValue": "Мән енгізіңіз",
        "updatedSuccessfully": "Сәтті жаңартылды",
        "infoDeleted": "Деректер жойылды",
        "tableDataHasBeenSuccessfullyEdited": "Кесте ақпараты сәтті түзетілді.",
        "formInfoSavedSuccessfully": " Пішін ақпараты сәтті сақталды.",
        "errorOccurredWhileUpdating": " Жаңарту кезінде қате орын алды.",
        "pleaseSelectUpdateLine": " Жаңарту үшін жолды таңдаңыз.",
        "errorOccWhileDeleting": "Жою кезінде қате орын алды",
        "errorMsg": "Кешіріңіз, қате орын алды",
        "noChangesHaveBeenReported": "Жаңартылған ақпарат жоқ",
        "theme":"Үлгі"
    },
    "dataSource": {
        "database": "Дерекқор",
        "add": "қосу",
        "view": "қараңыз",
        "pleaseEnterSearchValue": "Іздеу сөзіңізді енгізіңіз...",
        "pleaseWait": "Сәл күте тұрыңыз!",
        "yes": "Иә",
        "no": "Жоқ",
        "deleteData": "Деректерді жою керек пе?",
        "dataProcessing": "Мәліметтерді өңдеу",
        "characteristics": "Сипаттамалары",
        "basic": "Негізгі",
        "column": "Баған",
        "name": "Аты",
        "additional": "Қосымша",
        "filter": "Сүзгі",
        "data": "Деректер",
        "save": "Сақтау",
        "tableList": "Кестелер тізімі",
        "viewList": "View Тізім",
        "aggregation": "Біріктіру",
        "sort": "Сұрыптау",
        "noSort": "Сұрыпталмаған",
        "use": "Қолдану",
        "grouping": "Топтастыру",
        "type": "Түр",
        "alias": "Жалған есім",
        "select": "Таңдау",
        "bolomjitTableAndView": "Ықтимал кесте және көрініс",
        "selectTable": "Кестені таңдаңыз",
        "applications": "Бағдарламалар",
        "errorOccurredWhileSaving": "Сақтау кезінде қате орын алды!"
    },
    "role": {
        "administraationRightsManagment": "АРНАЛУДЫ БАСҚАРУ",
        "welcome": "Қош келдіңіз!",
        "loggedIn": "Жүйеге кірген пайдаланушы",
        "personalInfo": "Жеке ақпарат",
        "changePass": "Құпия сөзді өзгерту",
        "superAdminManagement": "Супер әкімші басқару",
        "logout": "Шығу",
        "pleaseWait": "Сәл күте тұрыңыз!",
        "add": "қосу",
        "pleaseSelectRole": "Рөлді таңдайсыз ба?",
        "role": "Міндет",
        "additional": "Қосымша",
        "dataSource": "Ақпараттың дереккөзі",
        "userList": "Пайдаланушылар тізімі",
        "import": "Импорттау",
        "register": "Тіркелу",
        "confirm": "Растау",
        "save": "Сақтау",
        "menuSelection": "Мәзірді таңдаңыз",
        "possibleTableView": "Ықтимал кесте және көрініс",
        "table": "Кесте",
        "name": "Аты",
        "displayName": "Көрсетілетін атау",
        "note": "Түсіндіру",
        "cancel": "Тоқта",
        "defaultMenu": "Әдепкі мәзір",
        "chart": "Графика",
        "tableName": "Кесте атауы",
        "table_name": "Кесте атауы"
    },
    "project": {
        "project": "ЖОБА",
        "settings": "Параметрлер",
        "data_recording_environment": "ҚАЗІРГІ ДЕРЕКТЕРДІ ЕНГІЗУ ГЕНЕРАТОРЫ",
        "_form": "Пішін",
        "table": "Кесте",
        "form_and_table_consolidation": "Пішіндерді және кестелерді біріктіру",
        "data_processor": "АҚПАРАТ ПРОЦЕССОРЫ",
        "_chart": "Графика",
        "original_preparation": "Бастапқы дайындық",
        "analysis": "Талдау",
        "target_statement": "Мақсатқа қатысты ескерту",
        "graphql_management": "Graphql басқару",
        "menu": "МӘЗІР",
        "menu_settings": "Мәзір параметрлері",
        "data_settings": "Деректер параметрлері",
        "project_key": "Жобаның кілті",
        "server_languege_framework": "Сервер жағындағы тіл және framework",
        "create_using": "пайдаланып жасау",
        "download_create_file": "Жүктеп алу файлын жасаңыз",
        "lambda": "Ламбда",
        "lambda_cli": "Ламбда CLI",
        "lambda_example_app": "Ламбда үлгісі қолданбасы",
        "l_key": "кілт",
        "create": "жасау",
        "lambda_settings": "Ламбда конфигурациясы",
        "laravel_framework": "PHP: Ларавелийн framework",
        "go_framework": "Go: Echo framework",
        "database": "Дерекқор",
        "database_connect": "Мәліметтер базасына қосылу",
        "ready": "Дайын",
        "_success": "Іске сәт",
        "type": "түрі",
        "manage_access_rights": "Қол жеткізуді басқару",
        "add": "қосу",
        "menuSelection": "Мәзірді таңдаңыз",
        "default_menu": "Әдепкі мәзір",
        "lambda_platform": "composer create-project lambda-platform/laravel",
        "composer": "Composer",
        "_save": "Сақтау",
        "optional": "Қосымша",
        "data_source": "Ақпараттың дереккөзі",
        "_moqup": "Мокуп",
        "user_list": "Пайдаланушы тізімі",
        "_import": "Импорттау",
        "register": "Тіркелу",
        "_confirm": "Растау",
        "deleteData": "Деректерді жою керек пе?",
        "form_value": "Пішін (мәнді алу)",
        "alertSelectColumns": "Сәйкес командаларды таңдаңыз",
        "errorMsg": "Кешіріңіз, қате орын алды",
        "please_wait": "Сәл күте тұрыңыз"
    },
    "puzzle": {
        "manage_access_rights": "Қол жеткізуді басқару",
        "data_recording_environment": "ҚАЗІРГІ ДЕРЕКТЕРДІ ЕНГІЗУ ГЕНЕРАТОРЫ",
        "_form": "Пішін",
        "table": "Кесте",
        "form_and_table_consolidation": "Пішіндерді және кестелерді біріктіру",
        "web_page": "Веб парақ",
        "data_processor": "АҚПАРАТ ПРОЦЕССОРЫ",
        "data_settings": "Деректер параметрлері",
        "_chart": "Графика",
        "original_preparation": "Бастапқы дайындық",
        "_report": "Есеп беру",
        "analysis": "Талдау",
        "target_statement": "Мақсатқа қатысты ескерту",
        "graphql_management": "Graphql басқару",
        "usersAndUserGroups": "ПАЙДАЛАНУШЫ ЖӘНЕ ҚОЛДАНУ ҚҰҚЫҚТАРЫ",
        "users": "Тұтынушылар",
        "userGroupsPermission": "Қол жеткізу және келісім",
        "menu_settings": "Мәзір параметрлері",
        "logOut": "Шығу",
        "cancel": "Тоқта",
        "please_wait": "Сәл күте тұрыңыз",
        "add": "қосу",
        "_save": "Сақтау",
        "optional": "Қосымша",
        "duties": "Міндет",
        "_name": "Аты",
        "appearance_name": "Көрсетілетін атау",
        "note": "Түсіндіру",
        "please_select_role": "Рөлді таңдаңыз",
        "data_source": "Ақпараттың дереккөзі",
        "_moqup": "Мокуп",
        "user_list": "Пайдаланушы тізімі",
        "_import": "Импорттау",
        "default_menu": "Әдепкі мәзір",
        "register": "Тіркелу",
        "_confirm": "Растау",
        "list_grid": "Тізім | Тор (сүзгі)",
        "custom_column": "Пайдаланушы бағаны",
        "judgment_column": "Бағалау бағанасы",
        "value_column": "Мән бағаны",
        "delete_data": "Деректерді жою",
        "menuSelection": "Мәзірді таңдаңыз",
        "not_found": "табылмады",
        "meaningTake": "Алатын мән",
        "filter": "Сүзгі"
    },
    "notify": {
        "notice": "Хабарландырулар",
        "no_notice": "Әзірге хабарландырулар жоқ!",
        "view_all_notifications": "Барлық хабарландыруларды көру",
        "total": "Барлығы",
        "clear_notification": "Оны барлығына көрсетіңіз"
    },
    "h5p": {
        "title": "H5P контент",
        "new_content": "Жаңа контент",
        "back": "Артқа",
        "view": "Көру",
        "edit": "Өңдеу",
        "loading": "Жүктелуде…",
        "load_error": "H5P жүктелмеді",
        "content_title": "Тақырып",
        "library": "Түрі",
        "updated": "Жаңартылды",
        "empty": "Әзірге контент жоқ.",
        "title_placeholder": "Тақырып",
        "save": "Сақтау",
        "saving": "Сақталуда…",
        "saved": "Сәтті сақталды.",
        "save_error": "Сақтау кезінде қате шықты",
        "incomplete": "Контент толық толтырылмаған.",
        "no_library": "Контент түрі таңдалмаған.",
        "step_type": "Түрін таңдау",
        "step_content": "Мазмұн дайындау",
        "step_back_confirm": "Жаңа түр таңдасаңыз, ағымдағы мазмұн жойылады. Жалғастыру керек пе?"
    },
    "appAdmin": {
        "manual": "Нұсқаулық",
        "logOut": "Шығу",
        "cancel": "Тоқта",
        "add": "қосу",
        "minus": "Жою",
        "pleaseWait": "Сәл күте тұрыңыз!",
        "pleaseEnterSearchValue": "Іздеу сөзіңізді енгізіңіз...",
        "delete_data": "Деректерді жою керек пе?",
        "no": "Жоқ",
        "yes": "Иә",
        "settings": "Параметрлер",
        "menu_location": "Мәзір орны",
        "stepped": "Иерархия",
        "stepped_small": "Иерархиялық шағын",
        "decomposes": "Ыдырады",
        "cross": "қарсы",
        "color_selection": "Түс таңдау",
        "dark_mode": "Қараңғы режим",
        "bright_mode": "Жарқын режим",
        "description": "Агенттерді қосқанда, дұрыс маршрут ақпаратын алу үшін оларды жоғарыдан төмен қарай енгізіңіз бе?",
        "data_processor": "Деректер процессоры",
        "original_preparation": "Бастапқы дайындық",
        "dataProcessing": "Мәліметтерді өңдеу",
        "graphics_generator": "Графикалық генератор",
        "point": "Нүкте"
    },
    "moqup": {
        "elements": "Элементтер",
        "chart": "Графика",
        "save": "Сақтау",
        "embedlink": "Сілтемені ендіру",
        "edit": "Түзет",
        "phone": "Телефон",
        "tablet": "Планшет",
        "computer": "Компьютер",
        "bigComputer": "Үлкен компьютер"
    },
    "page": {
        "pageNotFound": "Бет табылмады."
    },
    "alertMessage": {
        "anErrorOccurredWhileSaving": "Сақтау кезінде қате орын алды!",
        "successfullyDeleted": "Сәтті жойылды!",
        "plseEnterValue": "Мән енгізіңіз",
        "updatedSuccessfully": "Сәтті жаңартылды",
        "infoDeleted": "Деректер жойылды",
        "savedSuccessfull": "Сәтті сақталды",
        "confirm": "Растау",
        "errorOccurredWhileUpdating": " Жаңарту кезінде қате орын алды.",
        "pleaseSelectUpdateLine": " Жаңарту үшін жолды таңдаңыз.",
        "errorOccWhileDeleting": "Жою кезінде қате орын алды",
        "errorMsg": "Кешіріңіз, қате орын алды",
        "noChangesHaveBeenReported": "Жаңартылған ақпарат жоқ",
        "pleaseWait": "Сәл күте тұрыңыз!",
        "userDeleted": "Пайдаланушы жойылды",
        "successDeleted": "Сәтті жойылды!",
        "userInformationRe": "Пайдаланушы ақпараты қалпына келтірілді",
        "errorRetriev": "Деректерді алу кезінде қате пайда болды!",
        "notFound": "Іздеу нәтижелері табылмады!",
        "imformation_registered": "Сіздің ақпаратыңыз сәтті тіркелді. Сәл күте тұрыңыз",
        "errorServer": "Серверде қате орын алды",
        "errorSendingMail": "Электрондық поштаны жіберу кезінде қате орын алды",
        "please_enter_value": "Мән енгізіңіз",
        "formInformationSavedSuccessfully": "Пішін ақпараты сәтті сақталды.",
        "please_enter_formula": "Өз формулаңызды енгізіңіз",
        "errorSaving": "Сақтау кезінде қате орын алды!",
        "formIformationSavedSuccessfull": "Пішін ақпараты сәтті сақталды.",
        "selectDefaultMenu": "Әдепкі мәзірді таңдаңыз",
        "selectMenu": "Мәзірді таңдаңыз",
        "form_value": "Пішін (мәнді алу)",
        "alertSelectColumns": "Сәйкес командаларды таңдаңыз",
        "please_wait": "Сәл күте тұрыңыз",
        "pageNotFound": "Бет табылмады"
    },
    "crud": {
        "registration_history": "Тіркеу тарихы",
        "Information_viewing_history": "Тарихты көру",
        "_add": "қосу",
        "_save": "Сақтау",
        "re_call": "Қайта жүктеу",
        "_print": "Басып шығару",
        "download_file": "Excel файлымен жүктеп алыңыз",
        "excelUpload": "Excel файлынан деректерді импорттау"
    },
    // "custom": {
    //     "learningManagementSystem": "Оқытуды басқару жүйесі",
    //     "amjilt": "Жетістік",
    //     "system_features": "Жүйе мүмкіндіктері",
    //     "ebs": "Бастауыш мектеп",
    //     "web_site_data_monitoring": "Веб-сайт деректерін бақылау",
    //     "training_data_statistics": "Оқыту деректерінің статистикасы",
    //     "schedule_report": "Есепті жоспарлау",
    //     "track_by_keyword": "Кілт сөз бойынша қадағалау",
    //     "to_calculate_the_program_choice_of_teachers_and_students": "Мұғалімдер мен студенттердің бағдарлама таңдауын есептеу",
    // },
    i: {...iviewLocale.i}
}
